module.exports = __webpack_public_path__ + "img/flash.852d9d4b.png";